// extracted by mini-css-extract-plugin
export default {"container":"MD-z","dimension":"ND-z","dimensionLabels":"OD-z"};